export const ICON_SPRITE_URL =
  window.bawue2024.ICON_SPRITE_URL || '/media/icons/icons.svg';

export const LANG = document.documentElement.lang || 'de';

export const BREAKPOINTS = {
  s: ' 0em', // 0px
  m: ' 36.25em', // 580px
  l: ' 51.25em', // 820px
  xl: ' 64.0625em', // 1025px
  xxl: ' 68.125em', // 1090px
};

export const MEDIA_QUERIES = {
  s: '(min-width: 0em)',
  m: '(min-width: 36.25em)',
  l: '(min-width: 51.25em)',
  xl: '(min-width: 64.0625em)',
  xxl: '(min-width: 68.125em)',
};

export const COOKIESTATUS = {
  ACCEPT: 'accept',
  DECLINE: 'decline',
};

export const COOKIES = {
  MARKETING: [
    {
      name: 'bawu-youtube',
      expires: 100,
    },
    {
      name: 'bawu-instagram',
      expires: 100,
    },
    {
      name: 'bawu-vimeo',
      expires: 100,
    },
    {
      name: 'bawu-facebook',
      expires: 100,
    },
    {
      name: 'bawu-twitter',
      expires: 100,
    },
    {
      name: 'bawu-mastodon',
      expires: 100,
    },
    {
      name: 'bawu-soundcloud',
      expires: 100,
    },
    {
      name: 'bawu-datawrapper',
      expires: 100,
    },
  ],
  ANALYTICS: [
    {
      /**
       * This cookie is used to opt out of matomo tracking.
       * var analyticsCookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith("bawu-analytics="))
          ?.split("=")[1];

          _paq.push(["trackPageView"]);
          _paq.push(["enableLinkTracking"]);

          if (analyticsCookieValue !== "accept") {
            // require user cookie consent before storing any cookies
            // https://developer.matomo.org/guides/tracking-consent
            // "when the user has given consent, you could also avoid calling _paq.push(['requireConsent']) in the first place."
            _paq.push(["requireCookieConsent"]);
            console.info("Matomo cookies disabled until user consent is given.");
          }
          embedTrackingCode();
       */
      name: 'bawu-analytics',
      expires: 100,
    },
  ],
  CONSENT: [
    {
      name: 'bawu-consent',
      expires: 100,
    },
    {
      name: 'fontsLoaded',
      expires: 100,
    },
    // { Just for documentation purposes, this will be set by the components/organisms/popup/popup.js
    //   name: 'bawu-popup',
    //   expires: 7,
    // },
  ],
};

export const LINGUATEC_VOICE_READER_DO_NOT_READ_CLASS = 'js-shut-up';
